<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :row-class-name="rowClassNames" :columns="columns" :data="tableCaseDate" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="detail">
                <Button type="primary" size="small" @click="caseDetail(row)" v-hasPermission="['cases:case:detail']">{{ $t('ticket.list.detail') }}</Button>

                <span @click="doDelete(index)">
                    <Button type="warning" size="small" @click="processEasyModal = true" v-hasPermission="['cases:case:process']">{{ $t('ticket.list.Process') }}</Button>
                    <Button type="error" size="small" @click="caseDelmodal = true" v-hasPermission="['cases:case:delete']">{{ $t('ticket.list.delete') }}</Button>
                </span>
            </template>
        </Table>
        <!-- 删除案例模式框 -->
        <Modal v-model="caseDelmodal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{ticketEntityIds}} ?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeCase()" :disabled="isDisable">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
        <!-- 案例自动分配模式框 -->
        <Modal v-model="processEasyModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f90;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('ticket.list.keyDistribution') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('ticket.list.enableKeyDistribution') }}</p>
            </div>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="loadingProcessEasy" @click="removeProcessEasy()" :disabled="isDisableProcessEasy">{{ $t('ticket.list.allocation') }}</Button>
            </div>
        </Modal>
        <Modal v-model="caseEditModal" :title="$t('ticket.list.editTicket')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}">
            <Form ref="caseEditForm" :model="caseEditForm" :label-width="100" :rules="ruleValidate">
                <!-- 问题类型 -->
                <FormItem :label="$t('ticket.list.category')" prop="ticketCategory">
                    <Select v-model="caseEditForm.ticketCategory" filterable style="width:300px;" @on-change="changeTicketCategory">
                        <Option :value="item.id" v-for="item in ticketCategoryList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                 <!-- 功能类型 -->
                <FormItem :label="$t('satisfaction.functionCategory')" prop="functionType">
                    <Select v-model="caseEditForm.functionType" filterable style="width:300px;" @on-change="changeFunctionType">
                        <Option :value="item.id" v-for="item in functionTypeList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <div v-if="caseEditForm.continuePurchaseFlag==true">
                    <!-- 是否续买 -->
                    <FormItem :label="$t('ticket.list.continuePurchase')" prop="continuePurchase">
                        <Select v-model="caseEditForm.continuePurchase" filterable style="width:300px;">
                            <Option :value="item.index" v-for="item in continuePurchaseList" v-bind:key="item.index">{{item.value}}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 概要 -->
                <FormItem :label="$t('satisfaction.summary')" prop="outline">
                    <Input v-model="caseEditForm.outline" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>

                <!-- 状态 -->
                <FormItem :label="$t('satisfaction.status')" prop="status">
                    <Select v-model="caseEditForm.status" filterable style="width:300px;">
                        <Option value="0">{{ $t('ticket.list.Pending') }}</Option>
                        <Option value="1">{{ $t('ticket.list.Processing') }}</Option>
                        <Option value="2">{{ $t('ticket.list.Finish') }}</Option>
                        <Option value="3">{{ $t('ticket.list.WaitingForTheAuthorization') }}</Option>
                        <Option value="4" disabled>{{ $t('ticket.list.CheckNozzle') }}</Option>
                        <Option value="5">{{ $t('ticket.list.UnderReview') }}</Option>
                        <Option value="6">{{ $t('ticket.list.TheAuditFails') }}</Option>
                        <Option value="7">{{ $t('ticket.list.Approved') }}</Option>
                        <Option value="8">{{ $t('ticket.list.Confirming') }}</Option>
                        <Option value="9">{{ $t('ticket.list.Confirmed') }}</Option>
                    </Select>
                </FormItem>

                <div v-if="caseEditForm.status==2">
                    <!-- 关闭理由 -->
                    <FormItem :label="$t('ticket.list.closeReason')" prop="closeReason">
                        <Input v-model="caseEditForm.closeReason" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:300px;"></Input>
                    </FormItem>

                    <div v-if="((caseEditForm.status==2)&&(companyIdRow==companyIdCookie))">
                        <!-- 满意度 -->
                        <FormItem :label="$t('satisfaction.title')" prop="valueHalf">
                            <Rate allow-half v-model="caseEditForm.valueHalf"/>
                        </FormItem>
                    </div>
                </div>


                <!-- 监控模块 -->
                <FormItem :label="$t('ticket.list.monitorModule')" prop="monitorModule" >
                    <Input v-model="caseEditForm.monitorModule" disabled style="width:300px;"/>
                </FormItem>

                <!-- 审批流 -->
                <FormItem :label="$t('approvalFlowConfigManagement.approvalFlow.title')" prop="approvalFlow">
                    <div>{{this.caseEditForm.approvalFlow}}</div>
                </FormItem>

                <!-- 优先级 -->
                <FormItem :label="$t('ticket.list.level')" prop="priority">
                    <Select v-model="caseEditForm.priority" filterable style="width:300px;" disabled>
                        <Option :value="item.id" v-for="item in priorityList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 经办人 -->
                <FormItem :label="$t('ticket.list.assignee')" prop="agent">
                    <Select v-model="caseEditForm.agent" filterable style="width:300px;">
                        <Option v-for="(item,index) in agentList" :value="item.id" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 确认人 （“变更请求”和“定时任务管理”需要加“确认人”字段（必填）；） -->
                <div v-if="caseEditForm.ticketCategory == 5 || caseEditForm.ticketCategory == 6">
                    <FormItem :label="$t('ticket.list.confirmMan')" prop="confirmMan">
                        <Select v-model="caseEditForm.confirmMan" filterable style="width:300px;">
                            <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 公司 -->
                <div v-if="companyIdCookie==1">
                    <FormItem :label="$t('LabelConfig.LabelSynchronization.company')" prop="companyId">
                        <Select v-model="caseEditForm.companyId" filterable style="width:300px;">
                            <Option :value="item.id" v-for="(item,index) in companyIdList" v-bind:key="index">{{item.companyName}}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 附件 -->
                <FormItem :label="$t('LabelConfig.LabelSynchronization.attachment')" prop="enclosure">
                    <Upload  ref="upload" v-model="caseEditForm.enclosure" :on-success="uploadSuccess" :on-error="uploadError" :headers='{"userName": userName}' multiple type="drag" :action="actionUrl" style="width:300px;" :show-upload-list="true" :on-remove="handleRemove" :default-file-list="defaultList">
                        <div>
                            <Icon type="ios-cloud-upload" size="50" style="color: #3399ff"></Icon>
                            <p>{{ $t('message.uploadFile')}}</p>
                        </div>
                    </Upload>
                </FormItem>

                <!-- 描述 -->
                <FormItem v-show="isManualCase" :label="$t('ticket.list.description')" prop="describe">
                    <Input v-model="caseEditForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>
            </Form>
             <div slot="footer">
                <Button @click="caseReset('caseEditForm')">{{ $t('ticket.list.cancel') }}</Button>
                <Button type="primary" @click="caseSubmit('caseEditForm')" v-hasPermission="['cases:case:confirm']">{{showDetermineName}}</Button>
            </div>
        </Modal>
         <!-- :page-size-opts="[2,4,6,8]" -->
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    var tableCaseVue = {};
    export default {
        name: 'TableCase',
        data () {
            return {
                // 是否为手动案例标识
                isManualCase: false,
                companyIdCookie:getCookie(global.companyId),
                companyIdRow:'',
                showDetermineName:this.$t('common.determine'),
                current:1,
                dataTotal:0,
                pageSize:10,
                caseEditModal:false,
                loading:true,
                ticketEntityId:'',
                companyId:'',
                priorityIds:[],
                status:'',
                ticketCategory:'',
                cloudPlatformType:'',
                monitorModule:'',
                monitorIndex:'',
                caseEditForm: {
                    ticketCategory: '',
                    outline: '',
                    describe: '',
                    priority: '',
                    enclosure: '',
                    agent: '',
                    status:'',
                    monitorModule:'',
                    approvalFlow:'',
                    functionType:'',
                    closeReason:'',
                    valueHalf:0,
                    confirmMan: '',
                    companyId:'',
                    continuePurchase:'',
                    continuePurchaseFlag:''
                },
                continuePurchaseList:[],
                companyIdList:[],
                agentList:[],
                userName:getCookie(global.cookieName),//附件
                actionUrl:'',
                attachmentIDs:[],
                defaultList:[],
                allFileList:[],
                modal_loading: false, //删除
                caseDelmodal:false,
                isDisable: false,
                loadingProcessEasy: false, //一键分配
                processEasyModal:false,
                isDisableProcessEasy: false,
                createdTime: '',
                startTime: '',
                endTime: '',
                ticketEntityIds:'',
                // 问题类型
                ticketCategoryList: [],
                 // 功能类型
                functionTypeList:[],
                // 优先级别
                priorityList: [],
                ruleValidate: {
                    ticketCategory: [
                        { required: true, message: '请选择问题类型', trigger: 'change',type:'number'  }
                    ],
                    functionType: [
                        { required: true, message: '请选择功能类型', trigger: 'change',type:'number'  }
                    ],
                    companyId: [
                        {required: true, message: '请选择公司', trigger: 'change', type: 'number'}
                    ],
                    approvalFlow: [
                        { required: false, message: '请选择审批流', trigger: 'change', type: 'number' }
                    ],
                    continuePurchase: [
                        { required: false, message: '请选择是否续买', trigger: 'change', type: 'number' }
                    ],
                    outline: [
                        { required: true, message: '概要不能为空', trigger: 'blur' }
                    ],
                    describe: [
                        { required: true, message: '请输入描述', trigger: 'blur'}
                    ],
                    priority: [
                        { required: true, message: '请选择优先级', trigger: 'change',type:'number'  }
                    ],
                    status: [
                        { required: true, message: '请选择状态', trigger: 'change',type:'string' }
                    ],
                    agent: [
                        { required: true, message: '请选择经办人', trigger: 'change',type:'number' }
                    ],
                    valueHalf: [
                        { required: true, message: '请选择满意度', trigger: 'change',type:'number' ,min:0.5 }
                    ],
                    confirmMan: [
                        {  required: true, message: '请选择确认人', trigger: 'change',type:'number' }
                    ],
                    closeReason: [
                        { required: true, message: '请输入关闭理由', trigger: 'blur'},
                        { type: 'string', max: 1000, message: '最多输入1000个字符', trigger: 'blur' }
                    ]
                },
                columns: [
                    {
                        title: this.$t('ticket.list.ticketEntityID'),
                        key: 'ticketEntityId',
                        fixed: 'left',
                        minWidth: 200,
                        render: (h,params) => {
                            return h('a',{
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        const ticketSource = params.row.source;
                                        if (ticketSource == 0) {
                                            this.isManualCase = true;
                                        } else {
                                            this.isManualCase = false;
                                        }
                                        this.caseEditForm.id = params.row.id;
                                        // 附件
                                        tableCaseVue.showAllFileList();
                                        // 查询近经办人
                                        tableCaseVue.search();

                                        this.$api.ticket.getProblemType({
                                            "index": params.row.ticketCategory,
                                            "functionIndex": params.row.functionType
                                        }).then(res => {
                                            // 问题类型
                                            this.ticketCategoryList=res.data.problemTypeList;
                                            // 功能类型
                                            this.functionTypeList=res.data.functionTypeList;
                                            // 优先级
                                            this.priorityList=res.data.priorityLevelList;
                                        });


                                        this.caseEditModal=true;
                                        this.showDetermineName=this.$t('common.determine');
                                        // 问题类型
                                        /***************************************************************/
                                        this.caseEditForm.ticketCategory=params.row.ticketCategory;

                                        //功能类型
                                        this.caseEditForm.functionType=params.row.functionType;
                                        // 概要
                                        this.caseEditForm.outline = params.row.subject;
                                        // 状态
                                        this.caseEditForm.status = String(params.row.status);
                                        // 监控模块
                                        this.caseEditForm.monitorModule=params.row.monitorModuleName;
                                        // 优先级
                                        this.caseEditForm.priority = params.row.priorityId;
                                        // 经办人
                                        this.caseEditForm.agent = params.row.assigneeUserId;
                                        // 审批流
                                        this.caseEditForm.approvalFlow=params.row.processTemplateId;
                                        // 描述
                                        this.caseEditForm.describe = params.row.description;
                                        // 关闭理由
                                        this.caseEditForm.closeReason = params.row.closeReason;
                                        // 公司id
                                        this.companyIdRow=params.row.companyId;
                                        // 满意度
                                        if(params.row.satisfaction==null){
                                            this.caseEditForm.valueHalf=0;
                                        }else{
                                            this.caseEditForm.valueHalf=params.row.satisfaction;
                                        }
                                        // 是否续买
                                        this.$api.ticket.getContinuePurchaseBox({})
                                        .then(res => {
                                            this.continuePurchaseList=res.data;
                                        });
                                        this.caseEditForm.continuePurchaseFlag=params.row.continuePurchaseFlag;
                                        this.caseEditForm.continuePurchase=params.row.continuePurchase;
                                        // 公司列表
                                        this.$api.user.listRegisterInformation()
                                        .then(res => {
                                            // 获取公司列表数据
                                            this.companyIdList = res.data.companies;
                                        })
                                        this.caseEditForm.companyId=params.row.companyId;
                                    }
                                }
                            },params.row.ticketEntityId);
                        }
                    },
                    {
                        title: this.$t('ticket.list.subject'),
                        key: 'subject',
                        minWidth:190
                    },
                    {
                        title: this.$t('ticket.list.category'),
                        key: 'ticketCategoryName',
                        minWidth:140
                    },
                    {
                        title: this.$t('ticket.list.status'),
                        key: 'statusName',
                        minWidth: 120
                    },
                    {
                        title: this.$t('ticket.list.level'),
                        key: 'priorityName',
                        minWidth: 80
                    },
                    {
                        title: this.$t('ticket.list.assignee'),
                        key: 'assigneeUserName',
                        minWidth: 100
                    },
                    {
                        title: this.$t('ticket.list.createdTime'),
                        key: 'createdTime',
                        minWidth:150
                    },
                    {
                        title: this.$t('ticket.list.waitTime'),
                        key: 'waitTime',
                        minWidth:100
                    },
                    {
                        title: this.$t('ticket.list.handleTime'),
                        key: 'handleTime',
                        minWidth:100
                    },
                    {
                        title: this.$t('ticket.list.finishTime'),
                        key: 'finishTime',
                        minWidth:100
                    },
                    {
                        title: this.$t('ticket.list.isReply'),
                        key: 'isReply',
                        minWidth:100
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'detail',
                        fixed: 'right',
                        minWidth:180
                    }
                ],
                tableCaseDate:[]
            }
        },
        beforeCreate: function() {
            tableCaseVue = this
        },
        mounted: function(){
            tableCaseVue.getData();
            // 上传附件接口
            this.actionUrl=process.env.API_ROOT+'/sme/file/uploadFileS3';
        },
        methods:{
            // 状态为等待处理是 置顶加颜色
            rowClassNames (row) {
                if (row.statusName=='等待处理') {
                    return 'demo-table-info-row';
                }else{
                    return '';
                }
            },
            // 问题类型、状态
            getProblemType:function(){
                this.$api.ticket.getProblemType({})
                .then(res => {
                    // 问题类型
                    this.ticketCategoryList=res.data.problemTypeList;
                    this.caseEditForm.ticketCategory=this.ticketCategoryList[0].id;
                    /************功能类型*************************/
                    this.$api.ticket.getProblemType({
                        "index":this.caseEditForm.ticketCategory
                    })
                    .then(res => {
                        // 功能类型
                        this.functionTypeList=res.data.functionTypeList;
                        this.caseEditForm.functionType=this.functionTypeList[0].id;
                        /************优先级********************/
                        this.$api.ticket.getProblemType({
                            "functionIndex":this.caseEditForm.functionType
                        })
                        .then(res => {
                            // 优先级
                            this.priorityList=res.data.priorityLevelList;
                            this.caseEditForm.priority=this.priorityList[0].id;
                        })
                    })
                })
            },
            // 切换问题类型
            changeTicketCategory:function(){
                if(this.caseEditForm.ticketCategory==undefined){
                    return;
                }
                // 功能类型
                this.$api.ticket.getProblemType({
                    "index":this.caseEditForm.ticketCategory
                })
                .then(res => {
                    // 功能类型
                    this.functionTypeList=res.data.functionTypeList;
                    this.caseEditForm.functionType=this.functionTypeList[0].id;
                    // 优先级
                    this.priorityList=res.data.priorityLevelList;
                    this.caseEditForm.priority = res.data.priorityId;
                })
            },
            // 切换功能类型
            changeFunctionType:function(){
                if(this.caseEditForm.functionType==undefined){
                    return;
                }
                // 优先级
                this.$api.ticket.getProblemType({
                    "index":this.caseEditForm.ticketCategory,
                    "functionIndex":this.caseEditForm.functionType
                })
                .then(res => {
                    // 优先级
                    this.priorityList=res.data.priorityLevelList;
                    this.caseEditForm.priority = res.data.priorityId;
                })
            },
            // 切换审批流
            changeApprovalFlow:function(){
                // 如果不选审批流 显示确定 否则显示提交
                if(this.caseEditForm.approvalFlow==''){
                    this.showDetermineName=this.$t('common.determine')
                }else{
                    this.showDetermineName=this.$t('common.submit')
                }
            },
            // 查询近经办人
            search: function(){
                this.$api.user.selectAgent("userName",getCookie(global.cookieName))
                .then(res => {
                    this.agentList = res.data;
                })
            },
            // 点击查看详情跳转
            caseDetail: function(row){
                this.$router.push({path:'/cases/caseDetail/',query: {id: row.id}});
            },
            showAll: function(){
                tableCaseVue.getData();
            },
            cleanQueryData: function(){
                tableCaseVue.startTime='';
                tableCaseVue.endTime='';
            },
            // 分页显示数据
            /****************************************************/
            getData: function(){
                //获取CaseSearch里面的搜索内容
                eventBus.$on('ticketEntityId',function(val){
                    tableCaseVue.ticketEntityId=val;
                })
                eventBus.$on('companyId',function(val){
                    tableCaseVue.companyId=val;
                })
                eventBus.$on('priorityId',function(val){
                    tableCaseVue.priorityIds=val;
                })
                eventBus.$on('status',function(val){
                    tableCaseVue.status=val;
                })
                eventBus.$on('ticketCategory',function(val){
                   tableCaseVue.ticketCategory=val;
                })
                eventBus.$on('cloudPlatformType',function(val){
                   tableCaseVue.cloudPlatformType=val;
                })
                eventBus.$on('monitorModule',function(val){
                   tableCaseVue.monitorModule=val;
                })
                eventBus.$on('monitorIndex',function(val){
                   tableCaseVue.monitorIndex=val;
                })
                eventBus.$on('assigneeUserName',function(val){
                   tableCaseVue.assigneeUserName=val;
                })
                eventBus.$on('createdTime',function(val){
                   tableCaseVue.createdTime=val;
                })
                eventBus.$on('startTime',function(val){
                   tableCaseVue.startTime=val;
                })
                eventBus.$on('endTime',function(val){
                   tableCaseVue.endTime=val;
                })
                var pageTicketDate = {
                    "pageNum": this.current,
                    "pageSize": this.pageSize,
                    "priorityList":tableCaseVue.priorityIds,
                    "status":tableCaseVue.status,
                    "ticketEntityId":tableCaseVue.ticketEntityId,
                    "companyId":tableCaseVue.companyId,
                    "ticketCategory":tableCaseVue.ticketCategory,
                    "cloudPlatformType":tableCaseVue.cloudPlatformType,
                    "monitorModule":tableCaseVue.monitorModule,
                    "monitorIndex":tableCaseVue.monitorIndex,
                    "createdTime":tableCaseVue.createdTime,
                    "startTime":tableCaseVue.startTime,
                    "endTime":tableCaseVue.endTime,
                    "userName":tableCaseVue.assigneeUserName
                };
                if((this.$route.query.priorityId != undefined)&&(pageTicketDate.priorityList[0]=0)){
                    pageTicketDate.priorityList=JSON.parse(this.$route.query.priorityId);
                }

                // 状态
                if((this.$route.query.status != undefined)&&(pageTicketDate.status=='')){
                    pageTicketDate.status=this.$route.query.status;
                }

                //创建时间
                if((this.$route.query.createdTime != undefined)&&(pageTicketDate.createdTime=='')){
                    pageTicketDate.createdTime=this.$route.query.createdTime;
                }

                //当前月
                if (this.$route.query.currentMonth != undefined) {
                    pageTicketDate.currentMonth = this.$route.query.currentMonth;
                }


                this.$api.ticket.pageTicket(pageTicketDate)
                .then(res => {
                    this.tableCaseDate = res.data.records;
                    for(var i=0;i<this.tableCaseDate.length;i++){
                        // 响应时间
                        if(this.tableCaseDate[i].waitTime!=undefined){
                            this.tableCaseDate[i].waitTime=this.tableCaseDate[i].waitTime + this.$t('configuration_management.schedules.minute');
                        }
                        // 处理时间
                        if(this.tableCaseDate[i].handleTime!=undefined){
                            this.tableCaseDate[i].handleTime=this.tableCaseDate[i].handleTime + this.$t('configuration_management.schedules.minute');
                        }
                        // 完成时间
                        if(this.tableCaseDate[i].finishTime!=undefined){
                            this.tableCaseDate[i].finishTime=this.tableCaseDate[i].finishTime;
                        }else{
                            this.tableCaseDate[i].finishTime='N/A';
                        }
                    }
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                });
            },
            changePage: function(current){
                this.current=current;
                this.$route.query.pageNum=this.current;
                tableCaseVue.getData();
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                this.$route.query.pageSize=this.pageSize;
                tableCaseVue.getData();
            },
            // 销毁caseSearchID
            beforeDestroy: function(){
                eventBus.$off('caseSearchID');
            },
            // 附件
            /****************************************************/
            // 显示附件列表
            showAllFileList: function(){
                this.defaultList=[];
                this.$api.attatchment.selectByTicketId("id",this.caseEditForm.id)
                .then(res => {
                    this.allFileList=res.data;
                    for(var i=0;i<this.allFileList.length;i++){
                        this.defaultList.push({
                            response:{id: res.data[i].id},
                            name: res.data[i].fileName,
                            url: res.data[i].storagePath,
                            showProgress: false,
                            status: "finished"
                        });
                    }
                })
            },
            // 上传成功
            uploadSuccess (res, file,fileList) {
                this.$Message.success('上传成功');
                this.attachmentIDs.push(file.response.id);
            },
            // 上传失败
            uploadError(error, file) { //上传失败
                this.$Message.error('上传失败');
            },
            // 删除附件
            handleRemove(file,fileList){
                this.$api.file.deleteAttatchment("id",file.response.id)
                .then(res => {
                    this.$Message.success('删除成功');
                    this.attachmentIDs=[];
                    for(var i=0;i<fileList.length;i++){
                        this.attachmentIDs.push(fileList[i].response.id)
                    }
                })

            },
            // 一键分配
            /****************************************************/
            // 点击处理，案例自动分配
            removeProcessEasy: function(){
                this.isDisableProcessEasy = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                this.$api.ticket.processEasy({
                    "id":this.tableCaseDate[lineIndex].id
                })
                .then(res => {
                    this.loadingProcessEasy = true;
                    setTimeout(() => {
                        tableCaseVue.showAll();
                        this.isDisableProcessEasy = false;
                        this.loadingProcessEasy = false;
                        this.processEasyModal = false;
                        this.$Message.success('分配成功');
                    }, 1000);
                })
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.ticketEntityIds=this.tableCaseDate[index].ticketEntityId;
            },
            removeCase: function(){
                this.isDisable = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //案例删除
                this.$api.ticket.deleteTicket("id",this.tableCaseDate[lineIndex].id)
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        tableCaseVue.showAll();
                        this.isDisable = false;
                        this.modal_loading = false;
                        this.caseDelmodal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
            // 编辑案例
            /*************************************************************************/
            // 确定
            caseSubmit: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 编辑案例
                        this.$api.ticket.updateTicket({
                            "id":this.caseEditForm.id,
                            "ticketCategory":this.caseEditForm.ticketCategory,
                            "subject":this.caseEditForm.outline,
                            "status":this.caseEditForm.status,
                            "priorityId":this.caseEditForm.priority,
                            "assigneeUserId":this.caseEditForm.agent,
                            "description":this.caseEditForm.describe,
                            "attachmentIDs":this.attachmentIDs,
                            "functionType":this.caseEditForm.functionType,
                            "processTemplateId":this.caseEditForm.approvalFlow,
                            "closeReason":this.caseEditForm.closeReason,
                            "satisfaction":this.caseEditForm.valueHalf,
                            "companyId":this.caseEditForm.companyId,
                            "isTicketNotNull": true,
                            "continuePurchase":this.caseEditForm.continuePurchase
                        })
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                tableCaseVue.showAll();
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success('编辑成功');
                                this.$refs.upload.clearFiles();
                                this.attachmentIDs=[];
                                this.caseEditModal = false;
                            },1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error('编辑失败');
                    }
                });
            },
            // 取消
            caseReset: function(name){
                this.caseEditModal = false;
                // 删除所有附件
                this.$api.file.deleteByAttachmentIDs({
                    "attachmentIDs":this.attachmentIDs
                })
                .then(res => {
                    this.$refs.upload.clearFiles();
                    this.attachmentIDs=[];
                })
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
    .ivu-table .demo-table-info-row td{
        background-color: #c9c9c9;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/case/TableCase.vue